import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Check } from "lucide-react";
import { services } from "../data/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const empty = { name: "", email: "", phone: "", address: "", service: "", message: "" };

const QuoteForm = ({ defaultService = "", compact = false }) => {
  const [form, setForm] = useState({ ...empty, service: defaultService });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim()) {
      toast.error("Please add your name and email.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/quotes`, form);
      setDone(true);
      setForm({ ...empty, service: defaultService });
      toast.success("Quote request sent! We'll be in touch shortly.");
      setTimeout(() => setDone(false), 4000);
    } catch (err) {
      toast.error("Something went wrong. Please call us at (587)-216-4078.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="quote-form" className="space-y-7">
      <div className="grid md:grid-cols-2 gap-7">
        <div>
          <label className="fl-label">Name</label>
          <input data-testid="quote-name" className="fl-input" value={form.name} onChange={update("name")} placeholder="Your full name" />
        </div>
        <div>
          <label className="fl-label">Email *</label>
          <input data-testid="quote-email" type="email" className="fl-input" value={form.email} onChange={update("email")} placeholder="you@email.com" />
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-7">
        <div>
          <label className="fl-label">Phone</label>
          <input data-testid="quote-phone" className="fl-input" value={form.phone} onChange={update("phone")} placeholder="(587) 000-0000" />
        </div>
        <div>
          <label className="fl-label">Service</label>
          <select data-testid="quote-service" className="fl-input" value={form.service} onChange={update("service")}>
            <option value="">Select a service</option>
            {services.map((s) => (
              <option key={s.slug} value={s.title}>{s.title}</option>
            ))}
            <option value="Other">Other / General</option>
          </select>
        </div>
      </div>

      <div>
        <label className="fl-label">Address (Street, City, Postal Code)</label>
        <input data-testid="quote-address" className="fl-input" value={form.address} onChange={update("address")} placeholder="Property address" />
      </div>

      {!compact && (
        <div>
          <label className="fl-label">Project Details</label>
          <textarea data-testid="quote-message" rows={4} className="fl-input resize-none" value={form.message} onChange={update("message")} placeholder="Tell us about your project or special requests…" />
        </div>
      )}

      <button type="submit" data-testid="quote-submit" disabled={loading} className="btn-primary w-full md:w-auto disabled:opacity-60">
        {loading ? <Loader2 className="animate-spin mr-2" size={18} /> : done ? <Check className="mr-2" size={18} /> : null}
        {loading ? "Sending…" : done ? "Sent!" : "Request Free Quote"}
      </button>
    </form>
  );
};

export default QuoteForm;
